export const createFormDesignWidgetConfig = () => {
    return {
        title: '文本输入框',
        icon: 'vxe-icon-input',
        options: {
            placeholder: '请输入内容',
            clearable: true,
            maxLength: '',
            showWordCount: false,
            readonly: false,
            disabled: false,
        },
    };
};
